(function () {
  var DRAWER_SELECTOR = '#cartDrawer';
  var MOUNT_SELECTOR = '#storePickupApp';
  var START_EVENT = 'zapiet:start';
  var observer = null;
  var pendingTimer = null;
  var lastStart = 0;

  function getDrawer() {
    return document.querySelector(DRAWER_SELECTOR);
  }

  function getMount() {
    return document.querySelector(MOUNT_SELECTOR);
  }

  function dispatchZapietStart() {
    if (!getMount()) return;

    var now = Date.now();
    if (now - lastStart < 500) return;
    lastStart = now;

    document.dispatchEvent(new CustomEvent(START_EVENT));
  }

  function scheduleZapietStart(delay) {
    window.clearTimeout(pendingTimer);
    pendingTimer = window.setTimeout(dispatchZapietStart, delay || 250);
  }

  function isInsideZapietWidget(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.matches && node.matches(MOUNT_SELECTOR)) return true;
    return Boolean(node.closest && node.closest(MOUNT_SELECTOR));
  }

  function mutationBelongsToZapiet(mutation) {
    if (isInsideZapietWidget(mutation.target)) return true;

    if (!mutation.addedNodes.length && !mutation.removedNodes.length) return false;

    var addedInsideWidget = Array.prototype.every.call(mutation.addedNodes, function (node) {
      return node.nodeType !== 1 || isInsideZapietWidget(node);
    });
    var removedInsideWidget = Array.prototype.every.call(mutation.removedNodes, function (node) {
      return node.nodeType !== 1 || isInsideZapietWidget(node);
    });

    return addedInsideWidget && removedInsideWidget;
  }

  function getCartPageContainer() {
    if (!document.body.classList.contains('template-cart')) return null;
    return document.querySelector('main');
  }

  function observeCartContainers() {
    if (!window.MutationObserver) return;

    if (observer) observer.disconnect();
    observer = new MutationObserver(function (mutations) {
      var shouldRestart = mutations.some(function (mutation) {
        return !mutationBelongsToZapiet(mutation);
      });

      if (shouldRestart) scheduleZapietStart(300);
    });

    // The /cart page re-renders its sections via the Section Rendering API on
    // quantity changes, which replaces the #storePickupApp mount; watch <main>
    // there so the widget is re-initialised the same way the drawer is. On the
    // cart template the drawer has no mount (see cart-drawer.liquid), so the
    // drawer is deliberately NOT observed there — otherwise every drawer open
    // would re-fire zapiet:start against the page-level widget.
    var cartPage = getCartPageContainer();
    if (cartPage) observer.observe(cartPage, { childList: true, subtree: true });

    var drawer = cartPage ? null : getDrawer();
    if (drawer) observer.observe(drawer, { childList: true, subtree: true });

    if (drawer || cartPage) scheduleZapietStart(300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeCartContainers);
  } else {
    observeCartContainers();
  }

  document.addEventListener('shopify:section:load', observeCartContainers);
  document.addEventListener('cart:update', function () {
    scheduleZapietStart(800);
  });
  window.addEventListener('pageshow', function () {
    scheduleZapietStart(300);
  });
})();
